import { render, staticRenderFns } from "./RegionSavingsBadge.vue?vue&type=template&id=1fbaaf9c&scoped=true"
import script from "./RegionSavingsBadge.vue?vue&type=script&lang=ts"
export * from "./RegionSavingsBadge.vue?vue&type=script&lang=ts"
import style0 from "./RegionSavingsBadge.vue?vue&type=style&index=0&id=1fbaaf9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbaaf9c",
  null
  
)

export default component.exports